export { FeedMarketing } from './FeedMarketing'
